const About = {
    companyName: 'Dizen',
    social: {
        instagram: 'dizen.tour.guide',
        tiktok: '@dizen.tour.guide',
        linkedin: 'dizen-tour',
    },
};

export default About;
